import * as axios from './Axios'

const PREFIX = 'admin/venue'

export const _list = company_id => axios.get(`${PREFIX}/list?company_id=${company_id}`)
export const _types = () => axios.get(`${PREFIX}/types`)

export const _save = venue => axios.post(`${PREFIX}/save`, venue)
export const _update = (id, venue) => axios.put(`${PREFIX}/update/${id}`, venue)
export const _show = id => axios.get(`${PREFIX}/show/${id}`)
export const _delete = id => axios.del(`${PREFIX}/delete/${id}`)
export const _generateQR = id => axios.get(`${PREFIX}/generateQR/${id}`)
export const _removeQR = id => axios.get(`${PREFIX}/removeQR/${id}`)

// Nearby destinations / reusable places
// type: popular | hotel | city_center
export const _placesList = (type, company_id) =>
  axios.get(`${PREFIX}/places?type=${type}&company_id=${company_id}`)
export const _savePlace = place => axios.post(`${PREFIX}/places/save`, place)
export const _updatePlace = (id, place) => axios.put(`${PREFIX}/places/update/${id}`, place)

// venue portal
export const _savePortal = (id, portal) => axios.post(`${PREFIX}/${id}/portal/add`, portal)
export const _updatePortal = (venue_id, portal_id, portal) => axios.put(`${PREFIX}/${venue_id}/portal/${portal_id}/update`, portal)
export const _deletePortal = (venue_id, portal_id) => axios.del(`${PREFIX}/${venue_id}/portal/${portal_id}/delete`)
export const _updatePortalSettings = (venue_id,portal_id,data) => axios.put(`${PREFIX}/${venue_id}/portal/${portal_id}/settings`, data)

